import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Wrapped in `forwardRef`, which the stock shadcn source does not do.
 *
 * Stock targets React 19, where `ref` is an ordinary prop. This app is on React
 * 18, where it is not: without this, a `ref` passed to `Input` is swallowed and
 * React warns "Function components cannot be given refs". The Sold wizard needs
 * it — `DuplicatePolicyNotice`'s "correct the number" action focuses the
 * policy-number input via `TextField`'s `inputRef`.
 *
 * Re-running `npx shadcn@latest add input` will overwrite this. Re-apply it
 * until the app is on React 19.
 */
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  function Input({ className, type, ...props }, ref) {
  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(
        "h-9 w-full min-w-0 rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-input/30",
        "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50",
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
        className
      )}
      {...props}
    />
  )
})

export { Input }
